import { useFeatureStore, Feature } from '@getaccept/feature-restriction';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useEntityStore } from '../entity.store';
import type { MandatorySettingType } from '../enums/mandatory-setting-type';

export const useEntitySettings = () => {
  const { features } = storeToRefs(useFeatureStore());
  const { entity } = storeToRefs(useEntityStore());
  const immutableSettings = computed(() => entity.value?.settings?.immutableSettings);

  const isMandatory = (key: MandatorySettingType) => immutableSettings.value[key];

  const hasSmsEnabled = computed(
    () => !features.value[Feature.Sms].restricted && !!entity.value.securitySms
  );

  const hasQesEnabled = computed(
    () =>
      !features.value[Feature.QES].restricted &&
      !entity.value?.settings?.blockQualifiedElectronicSignature
  );

  const hasContextualCommenting = computed(
    () =>
      !features.value[Feature.ContextualCommenting].restricted &&
      entity.value?.settings?.contextualCommenting
  );

  const entitySettings = computed(() => ({
    [Feature.Sms]: hasSmsEnabled.value,
    [Feature.QES]: hasQesEnabled.value,
    [Feature.ContextualCommenting]: hasContextualCommenting.value,
  }));

  const reminderSettings = computed(() => ({
    reminderOpenedDays: entity.value?.reminderOpenedDays,
    reminderSignedDays: entity.value?.reminderSignedDays,
    reminderExpiredDays: entity.value?.reminderSignedDays,
  }));

  const hasAccess = (feature: Feature) => !!entitySettings.value[feature];

  return { entitySettings, hasAccess, isMandatory, reminderSettings };
};
